import React, { useState } from "react";
import { Box } from "@material-ui/core";

import { tabStyles } from "./styles";
import Table from "./Components/Table/Table";
import EditPriceModal from "./Components/EditPriceModal/EditPriceModal";
import SubscriptionViewModal from "./Components/ViewModal/SubscriptionViewModal";

const Subscription = () => {
  const classes = tabStyles();
  const [actionPerformed, setActionPerformed] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [editOpen, setEditOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);

  const handleEditButtonClick = (subscription) => {
    setSelectedSubscription(subscription);
    setEditOpen(true);
  };

  const handleViewButtonClick = (subscription) => {
    setSelectedSubscription(subscription);
    setViewOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setSelectedSubscription(null);
  };

  const handleViewClose = () => {
    setViewOpen(false);
    setSelectedSubscription(null);
  };

  const handleOnEditSuccess = () => {
    setActionPerformed(true);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.paddingAll}>
        <Table
          errorMsg={errorMsg}
          setErrorMsg={setErrorMsg}
          actionPerformed={actionPerformed}
          setActionPerformed={setActionPerformed}
          handleEditButtonClick={handleEditButtonClick}
          handleViewButtonClick={handleViewButtonClick}
        />
      </Box>
      {editOpen && (
        <EditPriceModal
          open={editOpen}
          handleClose={handleEditClose}
          subscription={selectedSubscription}
          handleOnSuccess={handleOnEditSuccess}
        />
      )}
      {viewOpen && (
        <SubscriptionViewModal
          open={viewOpen}
          handleClose={handleViewClose}
          subscription={selectedSubscription}
        />
      )}
    </Box>
  );
};

export default Subscription;
